import { Component, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {Store} from '@ngrx/store';

import {Subscription} from 'rxjs/Subscription';
import {Observable} from 'rxjs/Observable';

import { IApplicationState } from '../../../stateManagement/states/applicationState';
import { IAuthenticationDataState } from '../../../stateManagement/states/dataState';
import * as authenticationTypes from '../../types';
import * as fromRoot from '../../../stateManagement/rootReducer';
import { ServerLoginAction, ServerResetPasswordAction } from '../../../stateManagement/actions/data/authentication';
import { IPortalInfo } from '../../../shared/types';
import { ToasterService, ToasterConfig, BodyOutputType } from 'angular2-toaster/angular2-toaster';

@Component({
  selector: 'tr-authentication-container',
  templateUrl: './authentication-container.component.html',
  //styleUrls: ['./authentication-container.component.scss']
})
export class AuthenticationContainerComponent implements OnDestroy {
  curTab: number = 0;
  subscriptions: Array<Subscription> = [];
  isBusy$: Observable<boolean>;
  message: string;
  portalInfo$: Observable<IPortalInfo>;
  userName: string = '';
  constructor(
    private store: Store<IApplicationState>,
    private toasterService: ToasterService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.isBusy$ = this.store.select(fromRoot.isApplicationBusy);
    this.portalInfo$ = this.store.select(fromRoot.getApplicationPortalInformation);
    this.subscriptions.push(
      this.route.queryParams.subscribe(params => this.userName = params['username'] || ''),
      this.store.select(fromRoot.getAuthenticationDataState)
        .subscribe( (state: IAuthenticationDataState) => {
          this.message = (state.status) ? state.status.message : '';

          if (state.isNewRegisterUser) {
            this.router.navigate(['/authentication/updatePassword']);
          } 
          else if (state.isMFAEnabled && !state.isMFAAuthenticated) {
            this.router.navigate(['/authentication/mfaAuthentication']);
          }
          else if (state.isAuthenticated) {
              this.router.navigate(['/']);
          }

        })
    );
    toasterService.clear();
  }

  enableTab(tabIndex: number): void {
    this.message = '';
    this.curTab = tabIndex;
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  login(credentials: authenticationTypes.ICredentials): void {
    this.store.dispatch(new ServerLoginAction(credentials));
  }

  resetPassword(username: authenticationTypes.ICredentials): void {
    this.store.dispatch(new ServerResetPasswordAction(username));
  }

  showContent(tabIndex): void{
    this.enableTab(tabIndex);
  }

}



// WEBPACK FOOTER //
// ./src/app/authentication/containers/authentication-container/authentication-container.component.ts